import React from 'react';
import { Box, Theme, Typography } from '@material-ui/core';
import { Email } from '@material-ui/icons';
import { StringParam, useQueryParam } from 'use-query-params';
import { createStyles, makeStyles } from '@material-ui/styles';

import { SearchField } from '../../../../../common/inputs/SearchField';
import { AlertCard } from '../../../../../common/cards/alert-card/AlertCard';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '1rem',
    },
    headingRight: {
      display: 'flex',
      alignItems: 'center',
    },
    infoBody: {
      color: theme.alert.blue.dark,
      fontSize: '14px',
      fontWeight: 400,
    },
  })
);

export function TemplateHeader() {
  const [q, setQ] = useQueryParam('q', StringParam);

  const classes = useStyles();

  return (
    <Box>
      <Typography style={{ fontWeight: 600, fontSize: '16px', display: 'flex', alignItems: 'center' }}>
        <Email style={{ fontSize: '14px', paddingRight: '5px' }} /> Templates
      </Typography>
      <Typography variant={'body2'} style={{ fontSize: '14px', color: '#808080', marginBottom: '1rem' }}>
        {'View, edit, enable and disable communication templates sent to volunteers and users in your organization.'}
      </Typography>

      <AlertCard variant='info' title='About communication templates'>
        <Typography className={classes.infoBody}>
          These templates control the content and formatting of automated emails sent through your Volaby account. You
          can customize the message content, enable or disable specific communication types, and preview how they will
          appear to recipients. Some system-critical communications cannot be disabled to ensure proper platform
          functionality.
        </Typography>
      </AlertCard>

      <Box className={classes.heading}>
        <Typography style={{ fontWeight: 600, fontSize: '14px', color: '#666' }}>Available Templates</Typography>
        <Box className={classes.headingRight}>
          <SearchField value={q} onChange={(event) => setQ(event.target.value)} />
        </Box>
      </Box>
    </Box>
  );
}
